import Box from '@material-ui/core/Box';
import Divider from '@material-ui/core/Divider';
import Skeleton from '@material-ui/lab/Skeleton';
import React from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import SkeletonProductInfoRps from 'src/components/skeleton/SkeletonProductInfoRps';

const useStyles = makeStyles({
  radius16: {
    borderRadius: 16
  },
  radius6: {
    borderRadius: 6
  }
});
export default function SkeletonOrderTrackingItemRps() {
  const theme = useTheme();
  const classes = useStyles();

  return (
    <Box bgcolor={theme.palette.common.white} mb={2} borderRadius={8}>
      <Box px={2} py={1}>
        <Skeleton
          variant="rect"
          width={104}
          height={20}
          className={classes.radius6}
        />
      </Box>

      <Divider />

      <Box px={2} py={1} mt={1} display="flex" justifyContent="space-between">
        <SkeletonProductInfoRps />
      </Box>
    </Box>
  );
}
